export default __webpack_public_path__ + "static/media/ozp-trans-whitetext-medium.936a2d86.png";